<template>
    <div>
        <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
            <legal-user-account v-if="current_user.user_type == user_types.LEGAL" :user="user"></legal-user-account>
            <form v-else @submit.prevent="update" id="profile_form">
                <div class="d-flex align-items-center px-3">
                    <div class="ml-auto">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 0 24 24"
                            width="24px"
                            fill="#00bea5"
                        >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
                            />
                        </svg>
                        <span class="pr-2">حساب کاربری</span>
                    </div>
                    <div>
                        <button
                            type="submit"
                            class="btn btn-success px-4"
                            style="border-radius: 10px"
                            id="submit_btn"
                            :disabled="form_submit_loading"
                        >
            <span v-if="form_submit_loading">
              <span class="pl-2">در حال انجام</span>
              <span
                  class="spinner-border spinner-border-sm p-2"
                  role="status"
              ></span>
            </span>
                            <span v-else>ثبت تغییرات</span>
                        </button>
                    </div>
                </div>
                <hr />
                <div class="p-3">
                    <div class="d-flex align-items-center">
                        <div class="form-group w-50 px-3">
                            <label for="username">نام کاربری</label>
                            <input
                                type="text"
                                id="username"
                                class="form-control text-left"
                                v-model="user.username"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                        <div class="form-group w-50 px-3">
                            <label for="email">ایمیل</label>
                            <input
                                type="email"
                                id="email"
                                class="form-control text-left en_num"
                                v-model="user.email"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="form-group w-50 px-3">
                            <label for="name">نام</label>
                            <input
                                type="text"
                                id="name"
                                class="form-control"
                                v-model="user.first_name"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                        <div class="form-group w-50 px-3">
                            <label for="name_en"
                            >نام <small style="color: #bbb">انگلیسی</small>
                            </label>
                            <input
                                type="text"
                                id="name_en"
                                class="form-control text-left"
                                v-model="user.first_name_en"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="form-group w-50 px-3">
                            <label for="name">نام خانوادگی</label>
                            <input
                                type="text"
                                id="last_name"
                                class="form-control"
                                v-model="user.last_name"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                        <div class="form-group w-50 px-3">
                            <label for="name_en"
                            >نام خانوادگی <small style="color: #bbb">انگلیسی</small>
                            </label>
                            <input
                                type="text"
                                id="last_name_en"
                                class="form-control text-left"
                                v-model="user.last_name_en"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="form-group w-50 px-3">
                            <label for="father_name">نام پدر</label>
                            <input
                                type="text"
                                id="father_name"
                                class="form-control"
                                v-model="user.father_name"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                        <div class="form-group w-50 px-3">
                            <label for="father_name_en"
                            >نام پدر <small style="color: #bbb">انگلیسی</small>
                            </label>
                            <input
                                type="text"
                                id="father_name_en"
                                class="form-control text-left"
                                v-model="user.father_name_en"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="form-group w-50 px-3">
                            <label for="birth_date">تاریخ تولد</label>
                            <datePicker
                                color="#00c1a4"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="dddd jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="birth_date"
                                name="birth_date"
                                v-model="user.birth_date"
                                type="date"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                        <div class="form-group w-50 px-3">
                            <label for="id_number">کد ملی</label>
                            <input
                                type="text"
                                id="id_number"
                                class="form-control text-left"
                                v-model="user.national_code"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="form-group w-50 px-3">
                            <label for="mobile">شماره موبایل</label>
                            <input
                                type="text"
                                id="mobile"
                                class="form-control text-left"
                                :value="user.phone"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                        <div class="form-group w-50 px-3">
                            <label for="telephone">تلفن ثابت</label>
                            <input
                                type="text"
                                dir="ltr"
                                id="telephone"
                                class="form-control text-left"
                                v-model="user.telephone"
                                :disabled="user.is_authenticated"
                            />
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="form-group w-50 px-3">
                            <i class="la la-instagram ml-2" style="font-size: 15px"></i>
                            <label for="instagram">آی دی اینستاگرام (بدون @)</label>
                            <input
                                type="text"
                                dir="ltr"
                                id="instagram"
                                class="form-control text-left"
                                v-model="user.social_network.instagram"

                            />
                        </div>
                        <div class="form-group w-50 px-3">
                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-2" fill="#A0A0A1" viewBox="0 0 48 48"
                                 width="15px" height="15px">
                                <path
                                    d="M 15.173828 2.609375 C 11.917119 2.5264688 8.94875 4.7335781 8.1875 8.0332031 L 7.078125 12.837891 C 10.172125 7.7938906 15.497719 4.4664844 21.386719 3.8964844 L 16.582031 2.7871094 C 16.110656 2.6782344 15.639072 2.6212187 15.173828 2.609375 z M 24 7 C 14.628921 7 7 14.628928 7 24 C 7 33.371072 14.628921 41 24 41 C 33.371079 41 41 33.371072 41 24 C 41 14.628928 33.371079 7 24 7 z M 35.162109 7.078125 C 40.206109 10.172125 43.533516 15.497719 44.103516 21.386719 L 45.212891 16.582031 C 46.083891 12.811031 43.737797 9.0575 39.966797 8.1875 L 35.162109 7.078125 z M 24 10 C 31.74976 10 38 16.250245 38 24 C 38 31.749755 31.74976 38 24 38 C 16.25024 38 10 31.749755 10 24 C 10 16.250245 16.25024 10 24 10 z M 20.228516 13.697266 A 3.5 3.5 0 1 0 20.228516 20.697266 A 3.5 3.5 0 1 0 20.228516 13.697266 z M 30.802734 16.728516 A 3.5 3.5 0 1 0 30.802734 23.728516 A 3.5 3.5 0 1 0 30.802734 16.728516 z M 24 22.001953 A 1.999 1.999 0 1 0 24 25.998047 A 1.999 1.999 0 1 0 24 22.001953 z M 17.197266 24.271484 A 3.5 3.5 0 1 0 17.197266 31.271484 A 3.5 3.5 0 1 0 17.197266 24.271484 z M 3.8964844 26.615234 L 2.7871094 31.419922 C 1.9171094 35.190922 4.2622031 38.943453 8.0332031 39.814453 L 12.837891 40.923828 C 7.7948906 37.829828 4.4664844 32.504234 3.8964844 26.615234 z M 27.771484 27.302734 A 3.5 3.5 0 1 0 27.771484 34.302734 A 3.5 3.5 0 1 0 27.771484 27.302734 z M 40.923828 35.162109 C 37.829828 40.205109 32.504234 43.533516 26.615234 44.103516 L 31.419922 45.212891 C 35.190922 46.082891 38.943453 43.737797 39.814453 39.966797 L 40.923828 35.162109 z" />
                            </svg>
                            <label for="aparat">آی دی آپارات (بدون @)</label>
                            <input
                                type="text"
                                dir="ltr"
                                id="aparat"
                                class="form-control text-left"
                                v-model="user.social_network.aparat"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
            <form @submit.prevent="changePhoneNumber" id="profile_form">
                <div class="d-flex align-items-center px-3">
                    <div class="ml-auto">
                        <svg fill="#00bea5" height="24px" width="24px" version="1.1" id="Capa_1"
                             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                             viewBox="0 0 473.806 473.806" xml:space="preserve">
<g>
	<g>
		<path d="M374.456,293.506c-9.7-10.1-21.4-15.5-33.8-15.5c-12.3,0-24.1,5.3-34.2,15.4l-31.6,31.5c-2.6-1.4-5.2-2.7-7.7-4
			c-3.6-1.8-7-3.5-9.9-5.3c-29.6-18.8-56.5-43.3-82.3-75c-12.5-15.8-20.9-29.1-27-42.6c8.2-7.5,15.8-15.3,23.2-22.8
			c2.8-2.8,5.6-5.7,8.4-8.5c21-21,21-48.2,0-69.2l-27.3-27.3c-3.1-3.1-6.3-6.3-9.3-9.5c-6-6.2-12.3-12.6-18.8-18.6
			c-9.7-9.6-21.3-14.7-33.5-14.7s-24,5.1-34,14.7c-0.1,0.1-0.1,0.1-0.2,0.2l-34,34.3c-12.8,12.8-20.1,28.4-21.7,46.5
			c-2.4,29.2,6.2,56.4,12.8,74.2c16.2,43.7,40.4,84.2,76.5,127.6c43.8,52.3,96.5,93.6,156.7,122.7c23,10.9,53.7,23.8,88,26
			c2.1,0.1,4.3,0.2,6.3,0.2c23.1,0,42.5-8.3,57.7-24.8c0.1-0.2,0.3-0.3,0.4-0.5c5.2-6.3,11.2-12,17.5-18.1c4.3-4.1,8.7-8.4,13-12.9
			c9.9-10.3,15.1-22.3,15.1-34.6c0-12.4-5.3-24.3-15.4-34.3L374.456,293.506z M410.256,398.806
			C410.156,398.806,410.156,398.906,410.256,398.806c-3.9,4.2-7.9,8-12.2,12.2c-6.5,6.2-13.1,12.7-19.3,20
			c-10.1,10.8-22,15.9-37.6,15.9c-1.5,0-3.1,0-4.6-0.1c-29.7-1.9-57.3-13.5-78-23.4c-56.6-27.4-106.3-66.3-147.6-115.6
			c-34.1-41.1-56.9-79.1-72-119.9c-9.3-24.9-12.7-44.3-11.2-62.6c1-11.7,5.5-21.4,13.8-29.7l34.1-34.1c4.9-4.6,10.1-7.1,15.2-7.1
			c6.3,0,11.4,3.8,14.6,7c0.1,0.1,0.2,0.2,0.3,0.3c6.1,5.7,11.9,11.6,18,17.9c3.1,3.2,6.3,6.4,9.5,9.7l27.3,27.3
			c10.6,10.6,10.6,20.4,0,31c-2.9,2.9-5.7,5.8-8.6,8.6c-8.4,8.6-16.4,16.6-25.1,24.4c-0.2,0.2-0.4,0.3-0.5,0.5
			c-8.6,8.6-7,17-5.2,22.7c0.1,0.3,0.2,0.6,0.3,0.9c7.1,17.2,17.1,33.4,32.3,52.7l0.1,0.1c27.6,34,56.7,60.5,88.8,80.8
			c4.1,2.6,8.3,4.7,12.3,6.7c3.6,1.8,7,3.5,9.9,5.3c0.4,0.2,0.8,0.5,1.2,0.7c3.4,1.7,6.6,2.5,9.9,2.5c8.3,0,13.5-5.2,15.2-6.9
			l34.2-34.2c3.4-3.4,8.8-7.5,15.1-7.5c6.2,0,11.3,3.9,14.4,7.3c0.1,0.1,0.1,0.1,0.2,0.2l55.1,55.1
			C420.456,377.706,420.456,388.206,410.256,398.806z" />
        <path d="M256.056,112.706c26.2,4.4,50,16.8,69,35.8s31.3,42.8,35.8,69c1.1,6.6,6.8,11.2,13.3,11.2c0.8,0,1.5-0.1,2.3-0.2
			c7.4-1.2,12.3-8.2,11.1-15.6c-5.4-31.7-20.4-60.6-43.3-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3,3.7-15.6,11
			S248.656,111.506,256.056,112.706z" />
        <path d="M473.256,209.006c-8.9-52.2-33.5-99.7-71.3-137.5s-85.3-62.4-137.5-71.3c-7.3-1.3-14.2,3.7-15.5,11
			c-1.2,7.4,3.7,14.3,11.1,15.6c46.6,7.9,89.1,30,122.9,63.7c33.8,33.8,55.8,76.3,63.7,122.9c1.1,6.6,6.8,11.2,13.3,11.2
			c0.8,0,1.5-0.1,2.3-0.2C469.556,223.306,474.556,216.306,473.256,209.006z" />
	</g>
</g>
</svg>
                        <span class="pr-2">تغییر شماره موبایل</span>
                    </div>
                    <div>
                        <button
                            type="submit"
                            class="btn btn-success px-4"
                            style="border-radius: 10px"
                            id="change_phone_number_btn"
                        >

                            <span>ثبت تغییرات</span>
                        </button>
                    </div>
                </div>
                <hr />
                <div class="p-3">
                    <div class="alert alert-danger" v-if="this.error_message">{{this.error_message}}</div>
                    <div class="d-flex align-items-center">
                        <div class="form-group w-50 px-3">
                            <label for="phone">شماره موبایل جدید</label>
                            <input
                                type="text"
                                dir="ltr"
                                name="phone"
                                id="phone"
                                class="form-control text-left"
                                v-model="form_data.phone"
                            />
                        </div>
                        <div v-if="changeUserPhoneStep !== 'sendOtp'" class="form-group w-50 px-3">
                            <label for="code">کد اعتبار سنجی</label>
                            <input
                                type="text"
                                id="code"
                                name="code"
                                class="form-control text-left en_num"
                                v-model="form_data.code"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import $ from 'jquery';
import { userService } from '@/common/api.service';
import Inputmask from 'inputmask';
import { userTypes } from '@/constants/userTypes';
import LegalUserAccount from './legal-user-account';
import { KTApp } from '@/plugins/core/app';

export default {
    name: 'account',
    components: {
        LegalUserAccount
    },
    data() {
        return {
            user_types: userTypes,
            user: this.$store.state.user.current_user,
            form_submit_loading: false,
            form_data: {
                phone: null,
                code: null
            },
            changeUserPhoneStep: 'sendOtp',
            error_message: null
        };
    },
    computed: {
        ...mapState('user', {
            status: (state) => state.status
        }),
        ...mapGetters('user', [
            'current_user'
        ])
    },
    watch: {
        status() {
            this.user = this.$store.state.user.current_user;
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.initialSetup();
        });
    },
    methods: {
        changePhoneNumber(event) {
            let form = $(event.target);
            let btn = $('#change_phone_number_btn');
            this.error_message = null;

            if (this.changeUserPhoneStep === 'sendOtp') {
                return this.getOtpCode(form, btn);
            }

            form.validate({
                ignore: ':hidden',
                rules: {
                    phone: {
                        required: true,
                    },
                    code: {
                        required: true,
                    }
                }
            });

            if (!form.valid()) {
                return;
            }

            KTApp.progress(btn)
            let params = {
                phone: this.form_data.phone.replace('-', ''),
                code: this.form_data.code
            }

            userService
                .verificationPhoneNumber(params)
                .then(({ data }) => {
                    this.toastr.success(data.message)
                    this.changeUserPhoneStep = 'sendOtp';
                }).catch(({response})=> {
                form.validate().showErrors(response.data.data);
                this.error_message = response.data.message;
            }).finally(() => {
                KTApp.unprogress(btn);
            });



        },
        getOtpCode(form, btn) {
            form.validate({
                ignore: ':hidden',
                rules: {
                    phone: {
                        required: true,
                    },
                }
            });

            if (!form.valid()) {
                return;
            }

            KTApp.progress(btn)
            let params = {
                phone: this.form_data.phone.replace('-', '')
            }

            userService
                .changeUserPhoneNumber(params)
                .then(({ data }) => {
                    this.toastr.success(data.message)
                    this.changeUserPhoneStep = null;
                }).catch(({response})=> {
                    form.validate().showErrors(response.data.data);
                    this.error_message = response.data.message;
            }).finally(() => {
                KTApp.unprogress(btn);
            });
        },
        initialSetup() {
            setTimeout(() => {
                document.getElementById('telephone') &&
                Inputmask('099-99999999').mask(document.getElementById('telephone'));
                document.getElementById('phone') &&
                Inputmask('0999-9999999').mask(document.getElementById('phone'));
            }, 1000);
        },
        update(e) {
            let form = $(e.target);
            let btn = $('#submit_btn');
            let params = {};
            if (!this.user.is_authenticated) {
                form.validate({
                    ignore: ':hidden',
                    rules: {
                        username: {
                            required: true,
                            minlength: 5
                        },
                        first_name: {
                            required: true
                        },
                        last_name: {
                            required: true
                        },
                        first_name_en: {
                            required: true
                        },
                        last_name_en: {
                            required: true
                        },
                        national_code: {
                            required: true
                        },
                        birth_year: {
                            required: true
                        },
                        birth_month: {
                            required: true
                        },
                        birth_day: {
                            required: true
                        },
                        telephone: {
                            required: true
                        },
                        phone: {
                            required: true
                        },
                        email: {
                            required: true
                        }
                    }

                });
                if (!form.valid()) {
                    return;
                }
                if (!this.validateSocialId(this.user.national_code)) {
                    form.validate().showErrors({
                        national_code: i18n.t('validation.invalid_national_code')
                    });
                    return;
                }


                params = {
                    username: this.user.username,
                    first_name: this.user.first_name,
                    first_name_en: this.user.first_name_en,
                    last_name: this.user.last_name,
                    last_name_en: this.user.last_name_en,
                    father_name: this.user.father_name,
                    father_name_en: this.user.father_name_en,
                    national_code: this.user.national_code,
                    birth_date: this.user.birth_date,
                    phone: this.user.phone,
                    telephone: this.user.telephone,
                    email: this.user.email,
                    instagram: this.user.social_network.instagram,
                    aparat: this.user.social_network.aparat
                };
            } else {
                params = {
                    instagram: this.user.social_network.instagram,
                    aparat: this.user.social_network.aparat
                };
            }
            this.form_submit_loading = true;
            userService
                .update(params)
                .then((response) => {
                    this.$store.commit('user/success', response.data.data);
                    this.showMsg(form, 'success', response.data.message);
                })
                .catch(({ response }) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }
                    this.showMsg(form, 'danger', response.data.message);
                })
                .finally(() => {
                    this.form_submit_loading = false;
                });
        },
        validateSocialId(social_id) {
            var L = social_id.length;

            if (L < 8 || parseInt(social_id, 10) == 0) return false;
            social_id = ('0000' + social_id).substr(L + 4 - 10);
            if (parseInt(social_id.substr(3, 6), 10) == 0) return false;
            var c = parseInt(social_id.substr(9, 1), 10);
            var s = 0;
            for (var i = 0; i < 9; i++)
                s += parseInt(social_id.substr(i, 1), 10) * (10 - i);
            s = s % 11;
            return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
        },
    }
};
</script>

<style scoped>
/* --------- Step Style -------- */
.stepper-wrapper {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.stepper-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;

}

.stepper-item::before {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 20px;
    left: -50%;
    z-index: 2;
}

.stepper-item:first-child::after {
    width: 0;
}

.stepper-item::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 20px;
    left: 50%;
    z-index: 2;
}

.stepper-item .step-counter {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ccc;
    margin-bottom: 6px;
}

.stepper-item.active {
    font-weight: bold;
}

.stepper-item.completed .step-counter {
    background-color: #1aff66;
}

.stepper-item.completed::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #1aff66;
    width: 100%;
    top: 20px;
    left: 50%;
    z-index: 3;
}

.stepper-item.completed:first-child:after {
    width: 0;
}

.stepper-item.completed::before {
    position: absolute;
    content: "";
    border-bottom: 2px solid #1aff66;
    width: 100%;
    top: 20px;
    left: 50%;
    z-index: 3;
}

.stepper-item:first-child::before {
    content: none;
}

.stepper-item:last-child::after {
    content: none;
}

@media (max-width: 768px) {
    .stepper-item {
        font-size: 12px;
    }
}

/* --------- Step Style -------- */
</style>